import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import FileTypeAnalytics from 'src/components/dashboard/FileTypeAnalytics';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Autocomplete, Box, Grid, Tab, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import FlaggedAnalytics from 'src/components/dashboard/FlaggedAnalytics';
import ProjFileTypeAnalytics from 'src/components/dashboard/ProjFileTypeAnalytics';
import ProjFlaggedAnalytics from 'src/components/dashboard/ProjFlaggedAnalytics';
import TeamFileTypeAnalytics from 'src/components/dashboard/TeamFileTypeAnalytics';
import TeamFlaggedAnalytics from 'src/components/dashboard/TeamFlaggedAnalytics';
import DeptFlaggedAnalytics from 'src/components/dashboard/DeptFlaggedAnalytics';
import DeptFileTypeAnalytics from 'src/components/dashboard/DeptFileTypeAnalytics';
import OrgFlaggedAnalytics from 'src/components/dashboard/OrgFlaggedAnalytics';
import OrgFileTypeAnalytics from 'src/components/dashboard/OrgFileTypeAnalytics';
import OrgDeptWiseAnalytics from 'src/components/dashboard/OrgDeptWiseAnalytics';
import OrganizedAnalytics from 'src/components/dashboard/OrganizedAnalytics';
import SizeAnalytics from 'src/components/dashboard/SizeAnalytics';
import FileCategoryAnalytics from 'src/components/dashboard/FileCategoryAnalytics';
import FileSubCategoryAnalytics from 'src/components/dashboard/FileSubCategoryAnalytics';
import OrgSizeAnalytics from 'src/components/dashboard/OrgSizeAnalytics';
import OrgOrganizedAnalytics from 'src/components/dashboard/OrgOrganizedAnalytics';
import OrgFileCategoryAnalytics from 'src/components/dashboard/OrgFileCategoryAnalytics';
import OrgFileSubCategoryAnalytics from 'src/components/dashboard/OrgFileSubCategoryAnalytics';
import { getUsers } from 'src/services/user.service';
import config from 'src/config';
import OrganizationManagementPage from './OrganizationManagement.page';
import Settings from './Settings.page';
import PeopleAndAccessAnalytics from 'src/components/dashboard/PeopleAndAccessAnalytics';
import PercentIcon from '@mui/icons-material/Percent';
import OrgPeopleAndAccessAnalytics from 'src/components/dashboard/OrgPeopleAndAccessAnalytics';

class Dashboard extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            is_percentage: false,
            by: 'size',
            role: localStorage.getItem('role') || config.USER_ROLES.USER,
            value: 'mine',
            users: [],
            selected_user: null
        };
    }

    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve);
        });
    }

    async setUsers() {
        let users = await getUsers({minimal: true});
        if (users.error) {
            console.error(users.error);
            return;
        }
        users = users.users;

        users = users.map(user => {
            return {
                label: user.username,
                id: String(user._id)
            }
        });

        this.setState({
            users: users
        });
    }

    componentDidMount() {
        this.setUsers();
    }

    render() {
        return (
            <>

                <TabContext value={this.state.value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={(e, value) => {
                            this.setState({ value });
                        }} aria-label="lab API tabs example">
                            <Tab label="Mine" value="mine" />
                            {/* {(this.state.role != config.USER_ROLES.USER) ? (
                                <Tab label="Team" value="team" />
                            ) : null} */}
                            {(this.state.role != config.USER_ROLES.USER) ? (
                                <Tab label="Organization" value="org" />
                            ) : null}
                            {(this.state.role != config.USER_ROLES.USER) ? (
                                <Tab label="Manage" value="manage" />
                            ) : null}
                            {([config.USER_ROLES.SUPERADMIN,config.USER_ROLES.ADMIN].includes(this.state.role)) ? (
                                <Tab label="Settings" value="settings" />
                            ) : null}
                        </TabList>
                    </Box>
                    <TabPanel value="mine">

                        <SizeAnalytics
                            is_percentage={this.state.is_percentage}
                            by={this.state.by}
                        />
                        <br />
                        <FileSubCategoryAnalytics
                            is_percentage={this.state.is_percentage}
                            by={this.state.by}
                        />
                        <br />
                        <PeopleAndAccessAnalytics
                            is_percentage={this.state.is_percentage}
                            by={this.state.by}
                        />

                        <Grid item xs={12} style={{ paddingTop: 16 }}>
                            <ToggleButton
                                value="percentage"
                                selected={this.state.is_percentage}
                                onChange={() => this.setState((prevState) => ({ is_percentage: !prevState.is_percentage }))}
                                sx={{ mr: 2 }}
                                size='small'
                                color='primary'
                            >
                                <PercentIcon fontSize="small" />
                            </ToggleButton>

                            <ToggleButtonGroup
                                value={this.state.by}
                                exclusive
                                onChange={(e, value) => {
                                    if (value !== null) {
                                        this.setState({ by: value });
                                    }
                                }}
                                aria-label="file sub category analytics group"
                                color='primary'
                            >
                                <ToggleButton value="count" aria-label="left aligned" size="small">
                                    <Typography variant="body2" fontSize="small">Count</Typography>
                                </ToggleButton>
                                <ToggleButton value="size" aria-label="centered" size="small">
                                    <Typography variant="body2" fontSize="small">Size</Typography>
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>

                    </TabPanel>
                    {/* <TabPanel value="proj">
                        <ProjFileTypeAnalytics />
                        <br />
                        <ProjFlaggedAnalytics />
                    </TabPanel> */}
                    {/* <TabPanel value="team">

                        <Autocomplete
                            disablePortal
                            options={this.state.users}
                            renderInput={(params) => <TextField {...params} label="Team Member" />}
                            onChange={async (e, value) => {
                                await this.setStateAsync({ selected_user: null });
                                this.setState({
                                    selected_user: value
                                });
                            }}
                        />
                        <br />

                        {(this.state.selected_user) ? (
                            <>
                                <Grid item xs={12} style={{ paddingTop: 0, paddingBottom: 16 }}>
                                    <ToggleButton
                                        value="percentage"
                                        selected={this.state.is_percentage}
                                        onChange={() => this.setState((prevState) => ({ is_percentage: !prevState.is_percentage }))}
                                        sx={{ mr: 2 }}
                                        size='small'
                                    >
                                        <PercentIcon fontSize="small" />
                                    </ToggleButton>

                                    <ToggleButtonGroup
                                        value={this.state.by}
                                        exclusive
                                        onChange={(e, value) => {
                                            if (value !== null) {
                                                this.setState({ by: value });
                                            }
                                        }}
                                        aria-label="file sub category analytics group"
                                    >
                                        <ToggleButton value="count" aria-label="left aligned" size="small">
                                            <Typography variant="body2" fontSize="small">Count</Typography>
                                        </ToggleButton>
                                        <ToggleButton value="size" aria-label="centered" size="small">
                                            <Typography variant="body2" fontSize="small">Size</Typography>
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                </Grid>


                                <SizeAnalytics
                                    user_id={this?.state?.selected_user?.id}
                                    is_percentage={this.state.is_percentage}
                                    by={this.state.by}
                                />
                                <br />
                                <FileSubCategoryAnalytics
                                    user_id={this?.state?.selected_user?.id}
                                    is_percentage={this.state.is_percentage}
                                    by={this.state.by}
                                />
                            </>
                        ) : null}
                    </TabPanel> */}
                    <TabPanel value="org">

                        

                        <OrgSizeAnalytics
                            is_percentage={this.state.is_percentage}
                            by={this.state.by}
                        />
                        <br />
                        {/* <OrgOrganizedAnalytics />
                        <br />
                        <OrgFileCategoryAnalytics />
                        <br /> */}
                        <OrgFileSubCategoryAnalytics
                            is_percentage={this.state.is_percentage}
                            by={this.state.by}
                        />
                        <br />
                        <OrgPeopleAndAccessAnalytics
                            is_percentage={this.state.is_percentage}
                            by={this.state.by}
                        />
                        {/* <br />
                        <OrgFlaggedAnalytics /> */}

                        <Grid item xs={12} style={{ paddingTop: 16 }}>
                            <ToggleButton
                                value="percentage"
                                selected={this.state.is_percentage}
                                onChange={() => this.setState((prevState) => ({ is_percentage: !prevState.is_percentage }))}
                                sx={{ mr: 2 }}
                                size='small'
                                color='primary'
                            >
                                <PercentIcon fontSize="small" />
                            </ToggleButton>

                            <ToggleButtonGroup
                                value={this.state.by}
                                exclusive
                                onChange={(e, value) => {
                                    if (value !== null) {
                                        this.setState({ by: value });
                                    }
                                }}
                                aria-label="file sub category analytics group"
                                color='primary'
                            >
                                <ToggleButton value="count" aria-label="left aligned" size="small">
                                    <Typography variant="body2" fontSize="small">Count</Typography>
                                </ToggleButton>
                                <ToggleButton value="size" aria-label="centered" size="small">
                                    <Typography variant="body2" fontSize="small">Size</Typography>
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>

                    </TabPanel>
                    {(this.state.role != config.USER_ROLES.USER) ? (
                        <TabPanel value="manage">
                            <OrganizationManagementPage />
                        </TabPanel>
                    ) : null}
                    {([config.USER_ROLES.SUPERADMIN,config.USER_ROLES.ADMIN].includes(this.state.role)) ? (
                        <TabPanel value="settings">
                            <Settings />
                        </TabPanel>
                    ) : null}
                </TabContext>
            </>
        );
    }
}

// Wrap and export
export default function (props) {
    const navigate = useNavigate();
    const params = useParams();

    return <Dashboard {...props} navigate={navigate} params={params} />;
}
